<mat-toolbar color="primary" class="example-toolbar headerTop">
    <button mat-icon-button (click)="onToggleMenu()">
        <mat-icon aria-label="Toggle menu">menu</mat-icon>
    </button>

    <h1>District Website App</h1>

    <span fxFlex></span>

    <button mat-icon-button (click)="onToggleDarkTheme(isDarkTheme = !isDarkTheme)">
        <mat-icon 
            [matTooltip]="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'"
            [aria-label]="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'">
            {{ isDarkTheme ? 'light_mode' : 'dark_mode'}}
        </mat-icon>
    </button>

    <!-- <mat-chip-list>
    <mat-chip [matMenuTriggerFor]="menu">
      <mat-chip-avatar>
        <img class="avatar-image" src="https://www.w3schools.com/howto/img_avatar.png"/>
      </mat-chip-avatar>
      Name
    </mat-chip>
  </mat-chip-list> -->
    
    <button class="profileBtn" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon aria-hidden="false" aria-label="Account user icon">account_circle</mat-icon> 
    </button>

    <mat-menu #menu="matMenu" class="profileMenu">
        <mat-list class="wrapper">
            <mat-list-item class="user-info-grid">
                <div matListAvatar class="avatar-container">
                    <mat-icon class="avatar" aria-hidden="false" aria-label="Account user icon">account_circle</mat-icon>
                </div>
                <div matLine class="name">{{ user?.firstName }} {{ user?.lastName }}</div>
                <div matLine class="userRole">{{ role }}</div>
                <!-- <button mat-icon-button class="menuArrow" [matMenuTriggerFor]="settingsMenu" (click)="$event.stopPropagation()" aria-label="An icon of a gear for settings menu">
                    <mat-icon>settings</mat-icon>
                </button> -->
            </mat-list-item>
        </mat-list>
        <!-- <button mat-menu-item><mat-icon>person</mat-icon>Profile</button> -->
        <!-- <button mat-menu-item><mat-icon>settings</mat-icon>Settings</button> -->
        <mat-divider></mat-divider>
        <!-- <button mat-menu-item><mat-icon>help</mat-icon>Need Help?</button> -->
        <button mat-menu-item *ngIf="user; else sign_in" (click)="logout()">
            <mat-icon>login</mat-icon>Sign Out
        </button>

        <ng-template #sign_in>
            <button mat-menu-item (click)="login()">
                <mat-icon>login</mat-icon>Sign In
            </button>
        </ng-template>
    </mat-menu>
    <!-- <mat-menu #settingsMenu="matMenu" xPosition="before">
        <button mat-menu-item (click)="logout()">
            <mat-icon>login</mat-icon>Sign Out
        </button>
    </mat-menu> -->
</mat-toolbar>
